<template>
  <form>
    <section v-if="step == 1">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left" :class="{'ptclBgLeftSide':isReferBy==true}">
            <div class="align">
              <img v-if="isReferBy"
                   :src="require('@/assets/images/ptcl-group.png')"
                   width="193"
                   alt="Logo"
              />
              <h1 v-if="isReferBy">Customer</h1>
              <h1>Account Information</h1>
              <p>Enter information about account</p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <div class="signin-form ">
                <div class="signin-top">
                  <span class="text-primary">  Already have an account?</span>
                  <router-link :to="referByUrl">
                    <span class="btn btn-lg btn-outline-primary">Login</span>
                  </router-link>
                </div>
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>

                  <div class="stepper-wrapper">

                    <div class="stepper-item  active ">
                      <div class="step-counter"><i class=" ico ico-user"></i></div>
                      <div class="step-name">1. Account</div>
                    </div>
                    <div class="stepper-item ">
                      <div class="step-counter"></div>
                      <div class="step-name">2. Personal</div>
                    </div>
                    <div class="stepper-item ">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Phone Number</div>
                    </div>
                    <div class="stepper-item">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>
                  <!-- Step 1 -->
                  <div class="steps ">
                    <div class="row ">

                      <div class="pd-lr  " :class="this.referBy==='ptcl'?'col-lg-6 col-sm-6':'col-lg-12 col-sm-6'">
                        <div class="form-group">
                          <label><span>Company Name *</span></label>
                          <div class="input-wrapper">
                            <input type="text" v-validate="'required'" name="company_name" data-vv-as="Company Name"
                                   class="form-control form-control-lg "
                                   v-model="form.company.name" @change="validateInput('companyname')">
                          </div>
                          <p v-if="validity.companyName === 'invalid'"
                             :class="{textRed : validity.companyName === 'invalid'}">Enter company name</p>
                          <p v-text="errorCompanyName" class="text-danger">Already exists</p>
                        </div>
                      </div>
                      <div class="col-sm-6 pd-lr " v-if="this.referBy==='ptcl'">

                        <div class="form-group"   >
                          <label>SME ID *
                            <div class="custom-toltip">
                              <i class="ico-info" :class="{'SMEIDIconShow':isSMEIDValidate===true}"></i>
                              <div class="custom-toltip-hold" :class="{'SMEIDToltipShow':isSMEIDValidate===true}">
                                <div class="required-meaages">
                                  <h4>SME ID requirements:</h4>
                                  <div class="txt-size">
                                    <span class="txt-color" v-if="startPtclCode">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    Start with 033
                                  </div>
                                  <div class="txt-size">
                                    <span class="txt-color" v-if="tenChar">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    Length must be 10
                                  </div>
                                </div>
                              </div>
                            </div>
                          </label>
                          <div class="input-wrapper">
                            <input type="number" name="partner_customer_no" min="10" data-vv-as="Partner Customer No"
                                   class="form-control form-control-lg "
                                   @change="validateInput('partner_customer_no')"
                                   v-model="form.company.partner_customer_no">
                          </div>
                          <p v-if="validity.partner_customer_no === 'invalid'"
                             :class="{textRed : validity.partner_customer_no === 'invalid'}">Enter SME ID</p>
                        </div>

<!--                        <div class="form-group" v-else>
                          <label>CVR / Registration </label>
                          <div class="input-wrapper">
                            <input type="text" v-validate="'required'" name="company_cvr" data-vv-as="Company CVR"
                                   class="form-control form-control-lg"
                                   placeholder="" v-model="form.company.cvr">
                          </div>
                        </div>-->
                      </div>

                      <div class="col-sm-6 pd-lr ">
                        <div class="form-group">
                          <label><span>Address *</span></label>
                          <div class="input-wrapper">
                            <input type="text" v-validate="'required'" name="address"
                                   class="form-control form-control-lg " @change="validateInput('address')"
                                   placeholder="" id="companyAddress" v-model="form.company.address">
                          </div>
                          <p v-if="validity.address === 'invalid'"
                             :class="{textRed : validity.address === 'invalid'}">Enter address</p>
                        </div>
                      </div>
                      <div class="col-sm-6 pd-lr ">
                        <div class="form-group">
                          <label><span>Country *</span></label>
                          <div class="input-wrapper">
                            <select class="form-control form-control-lg " v-model="form.company.country"
                                    @change="getCurrency($event);">
                              <option v-for="(country,index) of countries" :key="index"> {{
                                  country.country
                                }}
                              </option>
                            </select>
                          </div>
                          <p v-if="validity.country === 'invalid'"
                             :class="{textRed : validity.country === 'invalid'}">Select country</p>
                        </div>
                      </div>
                      <div class="col-sm-6 pd-lr ">
                        <div class="form-group">
                          <label><span>City *</span></label>
                          <div class="input-wrapper">
                            <input type="text" v-validate="'required'" name="city"
                                   class="form-control form-control-lg " @change="validateInput('city')"
                                   placeholder="" v-model="form.company.city">
                          </div>
                          <p v-if="validity.city === 'invalid'" :class="{textRed : validity.city === 'invalid'}">Enter
                            city name</p>
                          <p v-if="validity.city === 'invalid-char'"
                             :class="{textRed : validity.city === 'invalid-char'}">invalid format</p>
                        </div>
                      </div>

                      <div class="col-sm-6 pd-lr ">
                        <div class="form-group">
                          <label><span>Email *</span></label>
                          <div class="input-wrapper">
                            <input v-validate="'required|email'" name="email" type="email"
                                   class="form-control form-control-lg "
                                   value="" placeholder="" v-model="form.email" @change="validateInput('email')">
                          </div>
                          <p v-if="validity.email === 'invalid'" :class="{textRed : validity.email === 'invalid'}">
                            Enter valid email</p>
                          <p v-text="errorMessage" class="text-danger">sad</p>
                        </div>
                      </div>

                      <div class="col-sm-6 pd-lr ">
                        <div class="form-group">
                          <label>
                            <span>Password *</span>
                            <div class="custom-toltip">
                              <i class="ico-info" :class="{'isIconRed':isPasswordValidate===true}"></i>
                              <div class="custom-toltip-hold" :class="{'passwordToltipShow':isPasswordValidate===true}">
                                <div class="required-meaages" v-show="pswdRequirements">
                                  <h4>Password requirements:</h4>
                                  <div class="txt-size"><span class="txt-color" v-if="eightChar">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    Must
                                    contain 8 characters
                                  </div>
                                  <div class="txt-size"><span class="txt-color" v-if="oneSpecial">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    One
                                    special character
                                  </div>
                                  <div class="txt-size"><span class="txt-color" v-if="oneCapital">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    One
                                    capital letter
                                  </div>
                                  <div class="txt-size"><span class="txt-color" v-if="oneLower">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    One
                                    small
                                    letter
                                  </div>
                                  <div class="txt-size">
                                    <span class="txt-color" v-if="oneNum">&#10004;</span>
                                    <span class="txt-color" v-else>❌</span>
                                    One number
                                  </div>
                                </div>
                              </div>
                            </div>
                          </label>
                          <div class="input-wrapper wrap1">
                            <input v-model="form.password"
                                   v-validate="{ required:true, regex: /|^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*).{8,}$/ }"
                                   name="password"
                                   type="password" class="form-control form-control-lg" id="signin-password"
                                   ref="password" @change="validateInput('password')">


                            <i class="ico-sec ico-eye_selected ico-pass"></i>
                          </div>
                          <p v-if="validity.password === 'invalid'"
                             :class="{textRed : validity.password === 'invalid'}">Enter password</p>
                        </div>

                      </div>
                      <div class="col-sm-6 pd-lr ">

                        <div class="form-group">
                          <label>Confirm Password</label>
                          <div class="input-wrapper wrap2">
                            <input v-model="form.confirmpassword" v-validate="'required|confirmed:password'"
                                   id="conform-password" name="password_confirmation" type="password"
                                   class="form-control form-control-lg" data-vv-as="password"
                                   @change="validateInput('confirm_password')">
                            <i class="ico-sec ico-eye_selected con-pass"></i>
                          </div>
                          <p v-if="validity.confirm_password === 'invalid'"
                             :class="{textRed : validity.confirm_password === 'invalid'}">Enter confirm password</p>
                          <p v-if="validity.confirm_password === 'invalid-match'"
                             :class="{textRed : validity.confirm_password === 'invalid-match'}">Password not
                            matched</p>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="tab-foot text-center">
                    <button v-if="step!=1" class="btn btn-lg btn-primary" @click.prevent="previousstep">Back</button>
                    <button type="button" class="btn btn-lg btn-outline-primary" @click="resetAccountInformation">
                      <span >Reset </span>
                    </button>
                    <button class="btn btn-lg btn-primary" :disabled="this.isDisabled"
                            @click.prevent="validateAndNext2ndProcess">Next
                    </button>

                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="step == 2">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left">
            <div class="align">
              <h1>Personal Information</h1>
              <p>Enter information about account</p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <div class="signin-form ">
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>
                  <div class="stepper-wrapper">

                    <div class="stepper-item  active complete">
                      <div class="step-counter"><i class=" ico ico-user"></i></div>
                      <div class="step-name">1. Account</div>
                    </div>
                    <div class="stepper-item active">
                      <div class="step-counter"></div>
                      <div class="step-name">2. Personal</div>
                    </div>
                    <div class="stepper-item ">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Phone Number</div>
                    </div>
                    <div class="stepper-item">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>
                  <!-- Step 1 -->
                  <div class="steps ">
                    <div class="row justify-content-center">

                      <div class="form-group col-sm-7">
                        <label><span>First Name *</span></label>
                        <div class="input-wrap">
                          <input type="text" class="form-control form-control-lg" placeholder="" value=""
                                 v-model="form.first_name" v-validate="'required'" name="first_name"
                                 data-vv-as="First Name" @change="validateInput1('firstname')">
                          <p v-if="validity1.firstname === 'invalid'"
                             :class="{textRed : validity1.firstname === 'invalid'}">First name is required</p>
                          <p v-if="validity1.firstname === 'invalid-char'"
                             :class="{textRed : validity1.firstname === 'invalid-char'}">First Name should be
                            character</p>

                        </div>
                      </div>

                      <div class="form-group col-sm-7">
                        <label for="last_name"><span>Last Name *</span></label>
                        <div class="input-wrapper">
                          <input type="text" class="form-control form-control-lg" placeholder=""
                                 v-model="form.last_name" v-validate="'required'" name="last_name"
                                 data-vv-as="Last Name" id="last_name" @change="validateInput1('lastname')">
                        </div>
                        <p v-if="validity1.lastname === 'invalid'"
                           :class="{textRed : validity1.lastname === 'invalid'}">Last name is required</p>
                        <p v-if="validity1.lastname === 'invalid-char'"
                           :class="{textRed : validity1.lastname === 'invalid-char'}">Last Name should be character</p>
                      </div>

                      <div class="form-group col-sm-7">
                        <label><span>Role</span></label>

                        <div class="input-wrapper roll-select">
                          <select name="" v-model="form.role" v-validate="'required'"
                                  data-vv-as="Roles" class="form-control form-control-lg text-capitalize"
                                  @change="validateInput1('role')">
                            <option class="text-capitalize" v-if="rolesList.length>0" v-for="(value,key) in rolesList"
                                    :value="value.name">{{ value.name }}
                            </option>
                          </select>
                        </div>
                        <p v-if="validity1.role === 'invalid'" :class="{textRed : validity1.role === 'invalid'}">Select
                          role</p>
                        <span v-show="errors.has('role')" class="form-error">{{ errors.first('role') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="tab-foot text-center">
                    <button v-if="step!=1" class="btn btn-lg btn-primary" @click.prevent="previousstep">Back</button>
                    <router-link :to="{ name: 'login'}">
                      <span class="btn btn-lg btn-cancel ">Cancel </span>
                    </router-link>
                    <button class="btn btn-lg btn-primary" @click.prevent="verify1">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="step == 3">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left">
            <div class="align">
              <h1>Phone Number</h1>
              <p>Please enter your phone number so
                we can verify your account</p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <div class="signin-form ">
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>

                  <div class="stepper-wrapper">

                    <div class="stepper-item  active complete">
                      <div class="step-counter"><i class=" ico ico-user"></i></div>
                      <div class="step-name">1. Account</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">2. Personal</div>
                    </div>
                    <div class="stepper-item active">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Phone Number</div>
                    </div>
                    <div class="stepper-item">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>


                  <!-- Step 1 -->
                  <div class="steps ">

                    <div class="form-row phone-step">
                      <div class="form-group col-sm-6">
                        <label>Phone Number</label>
                        <div class="input-wrapper">
                          <VuePhoneNumberInput style="padding-top: 5px"
                                               v-model.trim="phoneNum"
                                               :default-country-code="countryCode"
                                               size="sm"
                                               :translations="{countrySelectorLabel: ''}"
                                               :clearable="true"
                                               :show-code-on-list="true"
                                               @update="getFormatedNum"
                          />

                        </div>
                        <p v-text="errorMessage1" class="text-danger mt-5">Phone has already been taken</p>
                      </div>
                    </div>

                  </div>

                  <div class="tab-foot text-center">
                    <button v-if="step!=1" class="btn btn-lg btn-primary" @click.prevent="previousstep">Back</button>
                    <router-link :to="{ name: 'login'}">
                      <span class="btn btn-lg btn-cancel ">Cancel </span>
                    </router-link>

                    <button class="btn btn-lg btn-primary" :disabled="isActive" @click.prevent="verifyPhone">
                      <span> <clip-loader :loading="loading" :size="size"
                                          :color="spinnerColor"></clip-loader> Next </span>
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="step == 4">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left">
            <div class="align">
              <h1>Verification</h1>
              <p>Enter the 4-digit code</p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <div class="signin-form ">
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>

                  <div class="stepper-wrapper">

                    <div class="stepper-item  active complete">
                      <div class="step-counter"><i class=" ico ico-user"></i></div>
                      <div class="step-name">1. Account</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">2. Personal</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Phone Number</div>
                    </div>
                    <div class="stepper-item active">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>
                  <!-- Step 1 -->
                  <div class="steps ">

                    <div class="verification text-center">

                      <p>A verification code has been sent to an email and phone</p>
                      <a href="javascript:void(0)">{{ form.email }}</a>
                      <p>{{ form.phone }}</p>
                    </div>

                    <div class="form-row phone-step">
                      <ul class="otp-code" id="autojump">
                        <li>
                          <div class="input-wrapper  form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" ref="otp1" @paste="onPaste" data-otp="1"
                                   @keyup.delete="triggerDBKey" class="form-control form-control-lg" maxlength="1"
                                   v-model="verification_code[0]">
                          </div>
                        </li>
                        <li>
                          <div class="input-wrapper form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" ref="otp2" @keyup.delete="triggerDBKey"
                                   data-otp="2" class="form-control form-control-lg" maxlength="1"
                                   v-model="verification_code[1]">
                          </div>
                        </li>
                        <li>
                          <div class="input-wrapper form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" ref="otp3" @keyup.delete="triggerDBKey"
                                   data-otp="3" class="form-control form-control-lg" maxlength="1"
                                   v-model="verification_code[2]">
                          </div>
                        </li>
                        <li>
                          <div class="input-wrapper form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" ref="otp4" @keyup.delete="triggerDBKey"
                                   data-otp="4" class="form-control form-control-lg" maxlength="1"
                                   v-model="verification_code[3]">
                          </div>
                        </li>
                      </ul>
                      <p class="text-danger" v-show="veriCode">Verification Code is Invalid Or Expired</p>
                    </div>
                  </div>
                  <div class="tab-foot text-center mb-10">
                    <a href="javascript:void(0)" @click="resendVerificationCode(form.email)">
                      Resend code
                    </a>
                  </div>
                  <div class="tab-foot text-center">
                    <router-link :to="{ name: 'login'}">
                      <span class="btn btn-lg btn-cancel ">Cancel </span>
                    </router-link>
                    <button class="btn btn-lg btn-primary verifyPhoneNumber" :disabled="this.isDisableVerifyBtn"
                            @click.prevent="verifyPhoneNumber">
                      <clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>
                      Verify
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="step == 5">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left">
            <div class="align">
              <h1>Verification</h1>
              <p>Phone Verified </p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <form class="signin-form ">
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>

                  <div class="stepper-wrapper">

                    <div class="stepper-item  active complete ">
                      <div class="step-counter"><i class=" ico ico-user"></i></div>
                      <div class="step-name">1. Account</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">2. Personal</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Phone Number</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>
                  <!-- Step 1 -->
                  <div class="steps ">
                    <div class="verification-msg text-center ">
                      <i class="ico ico-double-tick"></i> <br>
                      <p>Verified Successfully</p>
                    </div>

                  </div>

                  <div class="tab-foot text-center">
                    <a @click.prevent="verify_user" class="btn btn-lg btn-block btn-primary"> Next</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>
<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Multiselect from 'vue-multiselect';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  name: 'signup',
  components: {VuePhoneNumberInput, Multiselect, ClipLoader},

  data() {
    return {
      step: 1,
      cnt: 1,
      pswdRequirements: true,
      isPasswordValidate: false,
      isSMEIDValidate: false,
      rolesList: [],
      jobRolesList: [],
      verification_code: [],
      countries: [],
      countryCities: [],
      size: '25px',
      spinnerColor: '#FFFFFF',
      referBy: this.$route.query.refer,
      countryCode: 'DK',
      submitted: false,
      isReferBy: false,
      form: {
        refer_by: this.$route.query.refer,
        first_name: '',
        role: '',
        last_name: '',
        type: 'MANAGER',
        email: '',
        phone: '',
        password: '',
        confirmpassword: '',
        address: '', //for employee only
        reg_no: '', //for employee only
        account_no: '', //for employee only
        tax_card_id: 2, //for employee only
        company: {
          "name": "",
          "partner_customer_no": "",
          "industry_id": "1",
          "cvr": "",
          "latitude": "",
          "longitude": "",
          "address": "",
          'city': '',
          'country': '',
          'currency': '',
          "job_roles": []
        }
      },
      validity: {
        cvr: '',
        companyName: '',
        email: '',
        address: '',
        city: '',
        country: '',
        currency: '',
        password: '',
        confirm_password: '',
        partner_customer_no: '',

      },
      validity1: {
        lastname: '',
        firstname: '',
        role: ''
      },
      defaultCountryCode: '',
      errorMessage: '',
      errorCompanyName: '',
      errorMessage1: '',
      isActive: false,
      loading: false,
      veriCode: false,
      isDisableVerifyBtn: false,
      phoneNum: '',
      inviteFormatNumber: '',
      limit: 0,
      tenChar: false,
      eightChar: false,
      oneSpecial: false,
      startPtclCode: false,
      oneCapital: false,
      oneLower: false,
      oneNum: false,
      referByUrl: 'login',

    }
  },
  validations: {
    form: {
      password: {
        required,
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          const containsLowercase = /[a-z]/.test(value);
          const containsNumber = /[0-9]/.test(value);
          const containsSpecial = /[#?!@$%^&*-]/.test(value);
          this.oneLower = containsLowercase;
          this.oneSpecial = containsSpecial;
          this.oneCapital = containsUppercase;
          this.oneNum = containsNumber;
          this.eightChar = value.length >= 8 ? true : false;
          if(this.oneLower===false || this.oneSpecial===false || this.oneCapital===false || this.oneNum===false|| this.eightChar===false){
            this.isPasswordValidate=true;
          }else {
            this.isPasswordValidate=false;
          }
          return (
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecial
          );
        },
        minLength: minLength(8),
      },
      company: {
        partner_customer_no: {
          // required,
          valid: function (value) {
            const startPtclCode = /^[033]/.test(value);
            this.startPtclCode = startPtclCode;
            this.tenChar = value.length >= 10 ? true : false;
            if(this.form.refer_by !=undefined && this.form.refer_by==='ptcl'){
              if( this.startPtclCode===false || this.tenChar===false ){
               // console.log( this.startPtclCode,' this.startPtclCode',this.tenChar,this.form.refer_by);
                this.isSMEIDValidate=true;

              }else{
                this.isSMEIDValidate=false;
              }

              return (
                startPtclCode
              );
            }else{
              return true;
            }


          },
           // minLength: minLength(10),
        },
      },
    },
  },
  watch: {
    form: {
      handler(val) {
        if (val.password == '') {
          this.oneLower = false;
          this.oneSpecial = false;
          this.oneCapital = false;
          this.oneNum = false;
          this.eightChar = false;

        }
      },
      deep: true
    }
  },
  created() {
    if (this.referBy !== '' && this.referBy !== undefined) {
      this.referByUrl= 'login?tok=%242y%2410%24g2JfOWb29IBR7maEAX8HuW5F5qV8UFqU3yp4G4pTaD41lzAbfYve%242y%2410%24g2JfOWb29IBR7maEAX8HuW5F5qV8UFqU3yp4G4pTaD41lzAbfYve&refer=ptcl',
      this.isReferBy = true;
    }
    return this.$v.$touch();
  },
  computed: {
    isDisabled() {
      return this.$v.$invalid;
    },
  },
  mounted() {
    localStorage.removeItem("user");
    this.getJobRolesList();
    this.getRolesList();
    this.getCountries();
    $(document).on('keypress', '.input-tel__input', function (e) {
      if (this.value.length == 0 && e.which == 48) {
        return e.preventDefault();
      }
    });
  },
  methods: {
    validateSMEID(value){
      if(this.referBy==='ptcl') {
        const startPtclCode = /^[033]/.test(value);
        this.startPtclCode = startPtclCode;
        this.tenChar = value.length >= 10 ? true : false;
        //console.log(startPtclCode,'startPtclCode ==',this.tenChar);
        if(this.tenChar===false || this.startPtclCode===false){
          this.isSMEIDValidate=true;
        }else{
          this.isSMEIDValidate=false;
        }
       // console.log(this.isSMEIDValidate,'this.isSMEIDValidate');
        if(value.length<10){
          return false
        }
        return (
          startPtclCode
        );
      } else {
       // console.log('refer by false');
        return true;
      }
    },
    resetAccountInformation(){
      this.form.company.name='';
      this.form.company.address='';
      this.form.company.city='';
      this.form.company.cvr='';
      this.form.company.country='';
      this.form.company.partner_customer_no='';
      this.form.email='';
      this.form.password='';
      this.form.confirmpassword='';
    },
    onPaste(evt) {
      this.verification_code = Array.from(String(evt.clipboardData.getData('text')), Number);
      return true;
    },
    triggerDBKey(e) {
      if ($(e.target).attr('data-otp') == 2) {
        this.$refs.otp1.focus();
      } else if ($(e.target).attr('data-otp') == 3) {
        this.$refs.otp2.focus();
      } else if ($(e.target).attr('data-otp') == 4) {
        this.$refs.otp3.focus();
      } else if ($(e.target).attr('data-otp') == 1) {
        this.$refs.otp1.focus();
      }
    },
    getFormatedNum(e) {
      let phoneLimit = e.phoneNumber ? e.phoneNumber.replace(/\s/g, '').length : '';
      if (e.isValid == true) {
        let numLength = String(e.formatNational).replace(/\s/g, '').length;
        this.limit = String(e.formatNational).substring(0, 1) == 0 ? numLength - 1 : numLength;
      }
      if (phoneLimit > this.limit && this.limit !== 0) {
        this.errorMessage1 = "Invalid phone number";
        this.isActive = true;
      } else {
        this.errorMessage1 = "";
        this.isActive = false;
        this.form.phone = e.formattedNumber;
      }
    },
    resendVerificationCode(email) {
      // alert(email)
      this.loading = true;
      this.$axios({
        method: "POST",
        data: {
          email: email
        },
        url: this.$ResendVerificationCode,
      }).then(res => {
        this.loading = false;
        if (res.data.status == 200) {
          $root.$toast.success(res.data.message);
        }
      });
    },
    getCurrency() {
      if (this.form.company.country) {
        this.validity.country = ''
      }
      var country = this.countries.filter(item => item.country === this.form.company.country)[0];
      this.form.company.currency = country.id;
      this.countryCode = country.ios2;
      this.countryCities = country.cities;
    },
    getRolesList() {
      this.$axios({
        method: 'get',

        url: this.$GetRolesList,
      }).then(response => {
          if (response.status === 200) {
            this.rolesList = response.data.result
          }
        }
      ).catch(error => {
        console.log(error);
        this.is_data_ready = true
      });
    },

    getCountries() {
      this.$axios({
        method: 'get',
        url: this.$GetCountries,
      }).then(response => {
        if (response.data.status === 200) {
          this.countries = response.data.result;
          // console.log(this.countries,'this.countries');
        }
      })
    },
    getJobRolesList() {
      let params = {list_type: ['job_roles']};
      this.$axios({
        method: 'get',
        params: params,
        url: this.$GetListofRoles,
      }).then(response => {
          if (response.data.status === 200) {
            this.jobRolesList = response.data.result.job_roles
          }
        }
      ).catch(error => {
        console.log(error);
        this.is_data_ready = true
      });
    },
    verifyPhone() {
      this.form.phone = this.form.phone.replace(/\s/g, '');
      this.phoneNum = this.form.phone.replace(/\s/g, '');
      var paramss = {phone: this.form.phone};
      if (paramss.phone !== '') {
        this.loading = true;
        this.$axios({
          method: "POST",
          data: paramss,
          url: this.$validatePhone,
          headers: this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            this.signup();
            this.isActive = true;
            this.errorMessage1 = '';
          } else if (res.data.status == 402) {
            this.loading = false;
            this.errorMessage1 = "Phone has already been taken";
          }
        });
      } else {
        this.errorMessage1 = "Phone number is required";
      }
    },
    signup() {
      this.isActive = true;
      this.$axios({
        method: 'post',
        data: $.param(this.form),
        url: this.$SignUp,
        // headers: this.getAuthHeader()
      }).then(response => {
          if (response.data.status === 200) {
            this.loading = false;
            $root.$toast.success('Code has been sent to your email');
            this.nextstep();
          }
        }
      ).catch(error => {
        console.log(error);
        this.is_data_ready = true
      });
    },
    nextSwitchFunc(e) {
      if ($(e.target).attr('data-otp') == 1) {
        this.$refs.otp2.focus();
      } else if ($(e.target).attr('data-otp') == 2) {
        this.$refs.otp3.focus();
      } else if ($(e.target).attr('data-otp') == 3) {
        this.$refs.otp4.focus();
      }
    },
    verifyPhoneNumber() {
      this.loading = true;
      this.isDisableVerifyBtn = true;
      this.form.phone = this.form.phone.replace(/\s/g, '');
      let data = {
        refer_by: (this.form.refer_by)?this.form.refer_by:'',
        partner_customer_no: this.form.company.partner_customer_no,
        phone: this.form.phone,
        verification_code: this.verification_code.join(''),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        fcm_token: 'web'
      };
      this.$root.$emit('activeCompoClick');

      this.$axios({
        method: 'post',
        data: $.param(data),
        url: this.$VerifyAccount,
      }).then(response => {
          this.isDisableVerifyBtn = false;
          this.loading = false;
          if (response.data.status === 200) {
            let user = response.data.result.user;
            this.$store.commit('setUser', user);
            localStorage.setItem('user', JSON.stringify(user));
            this.nextstep();
            this.veriCode = false;
          } else if (response.data.status === 402) {
            this.veriCode = true;
            this.verification_code = [];
            // $root.$toast.error('Verification Code is Invalid Or Expired');
          }
        }
      ).catch(error => {
        console.log(error);
        this.is_data_ready = true
      });
    },
    verify_user() {
      localStorage.setItem('isLogin', 1);
      this.$store.commit('setUser', JSON.parse(localStorage.getItem('user')));
      // this.$router.push({name: 'company-profile'});
      this.$router.push({name: 'upgrade-plan'});
    },
    nextstep() {
      this.step++;
    },
    previousstep() {
      this.step--;
    },
    clearRequiredCond() {
      this.validity.companyName = ''
      this.validity.email = ''
      this.validity.address = ''
      this.validity.city = ''
      this.validity.country = ''
      this.validity.currency = ''
      this.validity.password = ''
      this.validity.firstname = ''
      this.validity.lastname = ''
      this.validity.role = ''
      this.validity.cvr = ''
      this.validity.partner_customer_no = ''
    },
    clearRequiredCond1() {
      this.validity.firstname = ''
      this.validity.lastname = ''
      this.validity.role = ''
    },
    validateInput(fieldname = '') {
      if (fieldname === 'email' || fieldname === '') {
        var re = /\S+@\S+\.\S+/;
        if (this.form.email === '' || !re.test(this.form.email)) {
          this.validity.email = 'invalid'
        } else {
          this.validity.email = ''
        }
      }
      if (fieldname === 'companyname' || fieldname === '') {
        if (this.form.company.name === '') {
          this.validity.companyName = 'invalid'
        } else {
          this.validity.companyName = ''
        }
      }
      if (fieldname === 'partner_customer_no' || fieldname === '') {
        if (this.form.company.partner_customer_no === '' && this.referBy === 'ptcl') {
          this.validity.partner_customer_no = 'invalid'
        } else {
          this.validity.partner_customer_no = ''
        }
      }
      if (fieldname === 'address' || fieldname === '') {
        if (this.form.company.address === '') {
          this.validity.address = 'invalid'
        } else {
          this.validity.address = ''
        }
      }

      if (fieldname === 'city' || fieldname === '') {
        var cityregex = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;

        if (this.form.company.city === '') {
          this.validity.city = 'invalid'
        } else {
          if (this.form.company.city.match(cityregex) === null && this.form.company.city !== '') {
            this.validity.city = 'invalid-char'
          } else {
            this.validity.city = ''
          }
        }
      }

      if (fieldname === 'country' || fieldname === '') {
        if (this.form.company.country === '') {
          this.validity.country = 'invalid'
        } else {
          this.validity.country = ''
        }
      }

      if (fieldname === 'currency' || fieldname === '') {
        if (this.form.company.currency === '') {
          this.validity.currency = 'invalid'
        } else {
          this.validity.currency = ''
        }
      }
      if (fieldname === 'password' || fieldname === '') {
        if (this.form.password === '') {
          this.validity.password = 'invalid'
        } else {
          this.validity.password = ''
        }
      }
      if (fieldname === 'confirm_password' || fieldname === '') {
        if (this.form.confirmpassword === '') {
          this.validity.confirm_password = 'invalid'
        } else if (this.$validator.errors.has('password_confirmation') == true) {
          this.validity.confirm_password = 'invalid-match'
        } else {
          this.validity.confirm_password = '';
        }
      }
      if (this.validity.email == '' && this.validity.companyName == '' && this.validity.partner_customer_no == '' && this.validity.address == '' && this.validity.city == '' && this.validity.country == '' && this.validity.password == '' && this.validity.currency == '' && this.validity.confirm_password == '') {
        return true
      } else {
        return false
      }
    },
    validateInput1(fieldname = '') {
      var letters = /^[a-zA-Z0-9_ ]*$/;
      if (fieldname === 'firstname' || fieldname === '') {
        if (this.form.first_name === '') {
          this.validity1.firstname = 'invalid'
        } else {
          // if(this.form.first_name.match(letters) === null && this.form.first_name !== ''){
          // this.validity1.firstname = 'invalid-char'
          // }else{
          this.validity1.firstname = ''
          // }
        }
      }
      if (fieldname === 'lastname' || fieldname === '') {
        if (this.form.last_name === '') {
          this.validity1.lastname = 'invalid'
        } else {
          // if(this.form.last_name.match(letters) === null && this.form.last_name !== ''){
          // this.validity1.lastname = 'invalid-char'
          // }else{
          this.validity1.lastname = ''
          // }
        }
      }
      if (fieldname === 'role' || fieldname === '') {
        if (this.form.role === '') {
          this.validity1.role = 'invalid'
        } else {
          this.validity1.role = ''
        }
      }
      if (this.validity1.role == '' && this.validity1.firstname == '' && this.validity1.lastname == '') {
        return true
      } else {
        return false
      }
    },

    validateAndNext2ndProcess() {
      this.submitted = true;
      if (this.validateInput()) {
        this.$v.$touch();
        this.isPasswordValidate=true;
        if (this.$v.$invalid) {
          return false; // stop here if form is invalid
        } else {
          var paramss = {email: this.form.email, name: this.form.company.name};
          this.$axios
            .get(this.$validateEmailAndCompany, {
              params: paramss,
              headers: this.getAuthHeader()
            })
            .then(response => {
              if (response.data.status == 200) {
                this.errorCompanyName = '';
                this.errorMessage = '';
                this.nextstep();
              } else if (response.data.status === 402) {
                if (response.data.message == 'company') {
                  this.errorCompanyName = 'Company name already exist';
                  this.errorMessage = '';
                } else {
                  this.errorCompanyName = '';
                  this.errorMessage = 'Email already exist';
                }
              }
            })
            .catch(error => {
              console.log(error);
            })
          this.errorMessage = ''
        }
      }
    },

    verify1() {
      if (this.validateInput1()) {
        this.defaultCountryCode = this.form.company.country;
        this.countries.forEach(element => {
          if (element.country == this.defaultCountryCode) {
            this.defaultCountryCode = element.ios2
          }
        });
        this.nextstep();
      }
    },
  }
}
</script>
<style scoped>
.input-tel__input > label {
  top: 0px !important;
}

.textRed {
  color: red;
}

.borderRed {
  border: solid red;
}

.verifyPhoneNumber {
  position: relative;
}

.verifyPhoneNumber .v-spinner {
  position: absolute;
}

.txt-size {
  font-size: 14px;
}

.txt-color {
  color: red;
}
.ptclBgLeftSide{
  background: linear-gradient(to right, rgba(139, 184, 39, 1) 0%, rgba(0, 125, 66, 1) 100%) !important;
}
.passwordToltipShow{
  opacity: 1 !important;
  visibility:visible !important;
  border: 2px solid red;
  left: 40% !important;
}
.SMEIDToltipShow{
  opacity: 1 !important;
  visibility:visible !important;
  border: 2px solid red;
  left: 40% !important;
}
.isIconRed{
  color: red;
}
.SMEIDIconShow{
  color: red;
}
</style>
